export default __webpack_public_path__ + "static/media/polo-off.2f30566f.svg";